export default __webpack_public_path__ + "cu_dark.9aa00fd5.svg";